import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import PDFIcon from '@mui/icons-material/PictureAsPdfOutlined';

export default function SourceIcon({
  source,
  mimetype,
  size = 'medium',
  height = '24',
  width = '24',
}) {
  if (mimetype) {
    if (mimetype.startsWith('audio')) {
      return <MicNoneOutlinedIcon color="inherit" fontSize={size} />;
    }
    if (mimetype.startsWith('video')) {
      return <VideoLibraryOutlinedIcon color="inherit" fontSize={size} />;
    }
    if (mimetype === 'application/pdf') {
      return <PDFIcon color="inherit" fontSize={size} />;
    }

    // if is word
    if (
      mimetype ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return (
        <img
          src="/file_logos/ms_word.svg"
          alt="Microsoft Word Logo"
          width={width}
          height={height}
        />
      );
    }

    if (
      mimetype ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return (
        <img
          src="/file_logos/ms_excel.svg"
          alt="Microsoft Excel Logo"
          width={width}
          height={height}
        />
      );
    }
  }

  if (!source) {
    return <DescriptionOutlinedIcon color="inherit" fontSize={size} />;
  }

  if (source === 'google') {
    return (
      <img
        src="/google_meet_icon.svg"
        alt="Google Meet Logo"
        width={width}
        height={height}
      />
    );
  }

  if (source === 'teams') {
    return (
      <img
        src="/microsoft_teams_icon.svg"
        alt="Microsoft Teams Logo"
        width={width}
        height={height}
      />
    );
  }
  if (source === 'zoom') {
    return (
      <img src="/zoom_icon.png" alt="Zoom Logo" width={width} height={height} />
    );
  }
  if (source === 'recording') {
    return <MicNoneOutlinedIcon color="inherit" size={size} />;
  }

  if (source === 'phone') {
    return <PhoneOutlinedIcon color="inherit" size={size} />;
  }

  if (
    source !== 'phone' &&
    source !== 'recording' &&
    source !== 'google' &&
    source !== 'zoom' &&
    source !== 'teams'
  ) {
    return <AudioFileOutlinedIcon color="inherit" size={size} />;
  }
}
